import React from 'react';
import propTypes from 'prop-types';
import { Picture } from '_ui-core-js/React/components/Picture.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { AtmosphereImage } from './AtmosphereImage.jsx';

export function AtmosphereHeroImages(props) {

  const { images } = props;
  const block = 'c-atmosphere-hero-images';

  return (
    <div className={block}>
      <CssAnimation 
      enter={{ name: 'short-slide-up-fade-in', duration: 1.5, easing: 'ease-out' }} 
      triggerEnter={'in-view-init'}
      inViewProps={{ threshold: 0.2 }}
      >
        <div className={`${block}__image ${block}__image--left col-3`}>
          <AtmosphereImage base={images[0].base} animationDelay={0.01} />
        </div>
      </CssAnimation>
      <div className={`${block}__image ${block}__image--center col-12`}>
        <CssAnimation 
        enter={{ name: 'slide-up', duration: 1, easing: 'ease-out' }} 
        triggerEnter={'in-view-init'}
        >
          <div>
            <Picture base={images[1].base} />
          </div>
        </CssAnimation>
      </div>
      <CssAnimation 
      enter={{ name: 'short-slide-up-fade-in', duration: 1.5, delay: '0.35, hidden', easing: 'ease-out' }} 
      triggerEnter={'in-view-init'}
      inViewProps={{ threshold: 0.2 }}
      >
        <div className={`${block}__image ${block}__image--right col-3`}>
          <AtmosphereImage base={images[2].base} animationDelay={0.35} />
        </div>
      </CssAnimation>
    </div>
  )
};

AtmosphereHeroImages.propTypes = {
  images: propTypes.array.isRequired
};